<div class="container-fluid pb-3 pt-2">
  <h4 class="mb-2">{{headingText}}</h4>
  <h6>Ricerca di altri incarichi che hanno una polizza stipulata dal contraente dell'incarico corrente</h6>
  <resourceful-index [hidden]="!index?.customPaginator?.objectsCount" #index [search]="search"
    [modelService]="incaricoService" [columnDefinitions]="columnDefinitions" [relations]="relations">
  </resourceful-index>
  <div *ngIf="!index?.customPaginator?.objectsCount">
    Nessun pregresso trovato
  </div>

</div>